import {apolloClient} from "@/vue-apollo";
import QUERY_TEMPERATURES from "@/graphql/GetTemperatures.gql";

export const getTemperatures = async () => {
    return await apolloClient.query({
        query: QUERY_TEMPERATURES
    });
};

